/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedIconBubbleEmail_user$ref = any;
export type PdpSharedIconBubbleEmail_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": PdpSharedIconBubbleEmail_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedIconBubbleEmail_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '96e6b4733ec67b07b621e74786faffd4';
export default node;
